// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import SetupAuthenticator from './SetupAuthenticator';

export default {
  path: '/',
  name: 'Azure b2c',
  childRoutes: [
    {
      path: 'setup-authenticator',
      name: 'routes.setupAuthenticator',
      component: SetupAuthenticator,
    },
  ],
};
